import { ERouters } from '@qima-labs/app/shared/models/enums/routers.enum';
import { Route } from '@angular/router';

export const REPORT_GENERATION_ROUTES: Route[] = [
  {
    path: '',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./report-generation.component').then(m => m.ReportGenerationComponent),
  },
  {
    path: 'cs-test-result-search',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/cs-test-result-search/cs-test-result-search.component').then(m => m.CsTestResultSearchComponent),
  },
  {
    path: `${ERouters.ORDER_DETAIL}/:id`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/order-detail/order-detail.component').then(m => m.OrderDetailComponent),
    children: [
      {
        path: `${ERouters.OVERVIEW}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/over-view/over-view.component').then(m => m.OverViewComponent),
      },
      {
        path: `${ERouters.CPSC_EFILING}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/pages/cpsc-efiling/cpsc-efiling.component').then(m => m.CpscEfilingComponent),
      },
      {
        path: `${ERouters.FIRST_PAGE}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/first-page/first-page.component').then(m => m.FirstPageComponent),
      },
      {
        path: `${ERouters.TEST_RESULT_SETUP}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/test-result-setup/test-result-setup.component').then(m => m.TestResultSetupComponent),
      },
      {
        path: `${ERouters.TEST_PAGE}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/test-page/test-page.component').then(m => m.TestPageComponent),
      },
      {
        path: `${ERouters.TEST_RESULT_APPROVAL_PREVIEW}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () =>
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          import('./pages/order-detail/shared/pages/test-result-approval-preview/test-result-approval-preview.component').then(m => m.TestResultApprovalPreviewComponent),
      },
      {
        path: `${ERouters.ADD}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/operate-first-page/operate-first-page.component').then(m => m.OperateFirstPageComponent),
      },
      {
        path: `${ERouters.EDIT}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/operate-first-page/operate-first-page.component').then(m => m.OperateFirstPageComponent),
      },
      {
        path: `${ERouters.UPLOAD_RESULT_TABLE_FILE}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/upload-result-table-file/upload-result-table-file.component').then(m => m.UploadResultTableFileComponent),
      },
      {
        path: `${ERouters.NO_RESULT_TABLE}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/no-result-table/no-result-table.component').then(m => m.NoResultTableComponent),
      },
      {
        path: `${ERouters.TEST_APPROVAL}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/test-approval/test-approval.component').then(m => m.TestApprovalComponent),
      },
      {
        path: `${ERouters.TEST_REJECT}/:reportId`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/test-reject/test-reject.component').then(m => m.TestRejectComponent),
      },
      {
        path: `${ERouters.BATCH_GENERATE_FIRST_PAGE}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/order-detail/shared/pages/batch-generate-first-page/pages/add-page/add-page.component').then(m => m.AddPageComponent),
      },
      {
        path: `${ERouters.BATCH_GENERATE_FIRST_PAGE_ADD}`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () =>
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          import('./pages/order-detail/shared/pages/batch-generate-first-page/pages/batch-generate/batch-generate.component').then(m => m.BatchGenerateComponent),
      },
      {
        path: `${ERouters.FP_SINGLE_TEST_EDIT}/:reportId`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () =>
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          import('./pages/order-detail/shared/pages/batch-generate-first-page/pages/fp-single-test-edit/fp-single-test-edit.component').then(m => m.FpSingleTestEditComponent),
      },
      {
        path: `${ERouters.CUSTOMIZE_SECTION}/:reportId`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () =>
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          import('./pages/order-detail/shared/pages/customize-section/customize-section.component').then(m => m.CustomizeSectionComponent),
      },
    ],
  },
];
